import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import wait from "common/assets/js/wait";

const TabString = "	";

class InputArea extends React.Component<
  {
    text: string;
    setting: any;
    selectedMemoId: string;
    changeText: (newText: string) => void;
  },
  { textLength: number }
> {
  private textInputRef = React.createRef<HTMLTextAreaElement>();
  constructor(props) {
    super(props);
    this.state = {
      textLength: 0
    };
    this.textInputRef = React.createRef();
  }

  nentDidMount() {
    this._calcTextLength();
    window.addEventListener("keydown", this._keydown);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this._keydown);
  }
  componentDidUpdate = async prevProps => {
    const { text, selectedMemoId } = this.props;
    if (
      prevProps.text !== text ||
      this.props.setting.isNotIncludeSpace !==
        prevProps.setting.isNotIncludeSpace
    ) {
      this._calcTextLength();
    }
    if (selectedMemoId && prevProps.selectedMemoId !== selectedMemoId) {
      this.textInputRef.current.focus();
      this.textInputRef.current.setSelectionRange(0, 0);
      this.textInputRef.current.scrollTo(0, 0);
    }
  };
  _keydown = async e => {
    const isFocus = document.activeElement === this.refs.textInput;
    if (isFocus) {
      //TODO: enter時にmarkdownのlistを継続する
      //TODO: shift-tabで行頭のtabを戻す
      //tabでのfocusの遷移を止めつつスペースを入れる
      if (e.keyCode === 9) {
        e.preventDefault();
        const editor = e.target;
        const oldInput = editor.value;
        const posStart = editor.selectionStart;
        const posEnd = editor.selectionEnd;

        const newInput =
          oldInput.substring(0, posStart) +
          TabString +
          oldInput.substring(posStart, posEnd) +
          oldInput.substring(posEnd, oldInput.length);
        this.props.changeText(newInput);
        await wait(10);
        editor.focus();
        editor.selectionStart = posStart + TabString.length;
        editor.selectionEnd =
          posStart +
          TabString.length +
          oldInput.substring(posStart, posEnd).length;
      }
      //control + s を止める
      if (e.key === "s" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
      }
    }
  };
  _calcTextLength = () => {
    const { text, setting } = this.props;
    const { isNotIncludeSpace } = setting;
    this.setState({
      textLength: isNotIncludeSpace
        ? text.replace(/\s+/g, "").length
        : text.length
    });
  };
  render() {
    const { text } = this.props;
    const { textLength } = this.state;
    return (
      <Wrapper>
        <textarea
          ref={this.textInputRef}
          placeholder="メモ..."
          className="textinput"
          onChange={e => this.props.changeText(e.target.value)}
          value={text}
        />
        <p className="info">
          <span>{textLength}文字</span>
        </p>
      </Wrapper>
    );
  }
}

export default connect(({ setting }) => ({ setting }))(InputArea);

const Wrapper = styled.div`
  flex-grow: 1;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  -webkit-overflow-scrolling: touch;
  .textinput {
    flex-grow: 1;
    box-sizing: border-box;
    padding: 12px 16px;
    font-size: 13px;
  }
  .info {
    border-top: 1px solid #f5f5f5;
    color: #999;
    padding: 0.5em 1em;
  }
`;
